import type { MaybeAuthSession } from '@context/AuthContext'

import { getCompanyName } from '@utils/companyName.utils'

import { type IdentifyProperties } from '../../ampli'

export const getAmplitudeIdentifyProperties = (
  auth?: MaybeAuthSession | null
): IdentifyProperties | undefined => {
  const tickmillCompanyId = auth?.tickmillCompany?.id

  if (tickmillCompanyId === undefined || tickmillCompanyId === null) {
    return undefined
  }

  return {
    tickmill_entity: getCompanyName(tickmillCompanyId),
  }
}
